// utils/fetchWithAuth.ts
export const fetchWithAuth = async (
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> => {
  const response = await fetch(input, init);

  // If the server returns unauthorized, handle it
  if (!response.ok && response.statusText === "Unauthorized") {
    // Redirect the user to the home page and display a message
    window.location.href = "/?message=Session expired, please log in again";
  }

  return response; // Continue if no issues
};
